export const DEFAULT_CITY_VALUE = 'Remote';

export const CITIES_ALIASES: { [key: string]: string } = {
  Odessa: 'Odesa',
  Chernovtsy: 'Chernivtsi',
};

export const MAX_CITY_TRAVEL_TIME_HRS = 2;
